import {
  createSignalAction,
  createSimpleCreator,
} from "shared/reduxUtils"

const BASE = "ZILLOW_MEGRE"

export const toggleZillowMergeModalAction = createSimpleCreator(BASE, "TOGGLE_ZILLOW_MERGE_MODAL")
export const fetchReferalForMergeAction = createSignalAction(BASE, "FETCH_REFERALS_FOR_MERGE")
export const mergeZillowLeadsAction = createSignalAction(BASE, "MERGE_ZILLOW_LEADS")